export default __webpack_public_path__ + "static/media/77.1d8d6be5.jpg";